export const createBalloonLayout = () => {
	const balloonLayout = ymaps.templateLayoutFactory.createClass(
		'<div class="popup"><div class="arrow"></div><div class="content">$[properties.balloonContent]</div></div>',
		{
			build: function () {
				this.constructor.superclass.build.call(this);

				this.setBalloonProperties();

				const popupClickHandler = () => {
					this.getElement().firstElementChild.removeEventListener(`click`, popupClickHandler);
					this.getData().collection.getObjectManager().getMap().balloon.close();
				};
				
				setTimeout(() => this.getElement().firstElementChild.addEventListener(`click`, popupClickHandler), 40);
			},
			setBalloonProperties: function () {
				this.properties = {};
				this.properties.mapNode = this._element.closest(`div.map`);
				this.properties.popupNode = this._element.querySelector(`div.popup`);
				this.properties.arrowNode = this._element.querySelector(`div.arrow`);

				this.properties.mapWidth = this.properties.mapNode.offsetWidth;
				this.properties.mapHeight = this.properties.mapNode.offsetHeight;
				this.properties.arrowHeight = this.properties.arrowNode.offsetHeight;
				this.properties.pinHeight = this.getData().object.properties.size.height;
				this.properties.popupWidth = this.properties.popupNode.offsetWidth;
				this.properties.popupHeight = this.properties.popupNode.offsetHeight + this.properties.arrowHeight;
				this.properties.popupOffset = 8;
				this.properties.popupTopPosition = this.properties.popupOffset + this.properties.arrowHeight;
				this.properties.popupBottomPosition = ( this.properties.popupOffset + this.properties.pinHeight + this.properties.popupHeight ) * -1;
				this.properties.popupLeftPosition = this.properties.popupWidth / -2;
			},
			getShape: function () {
				if ( this._element )
				{
					const popupPos = this.properties.popupNode.getBoundingClientRect();
					const mapPos = this.properties.mapNode.getBoundingClientRect();
					const isPopupBottom = popupPos.top > mapPos.top + this.properties.mapHeight / 2;
					const isPopupRight = popupPos.left > mapPos.left + this.properties.mapWidth / 2;

					this._element.classList.remove(`on-top`);
					this._element.classList.remove(`on-bottom`);
					this._element.classList.remove(`on-right`);
					this._element.classList.remove(`on-left`);
					isPopupBottom ? this._element.classList.add(`on-top`) : this._element.classList.add(`on-bottom`);
					isPopupRight ? this._element.classList.add(`on-right`) : this._element.classList.add(`on-left`);

					this._element.style.bottom = `${this.properties.pinHeight / 2}px`;
					// const isPopupOverBottomMap = popupPos.top + this.properties.popupHeight > mapPos.top + this.properties.mapHeight;
					// const isPopupOverRightMap = popupPos.left + this.properties.popupWidth > mapPos.left + this.properties.mapWidth;
					//
					// this._element.classList.remove(`on-top`);
					// this._element.classList.remove(`on-bottom`);
					// this._element.classList.remove(`on-right`);
					// this._element.classList.remove(`on-left`);
					// isPopupOverBottomMap ? this._element.classList.add(`on-top`) : this._element.classList.add(`on-bottom`);
					// isPopupOverRightMap ? this._element.classList.add(`on-right`) : this._element.classList.add(`on-left`);
					//
					// this._element.style.bottom = `${this.properties.pinHeight / 2}px`;
				}
			},
		});

	return balloonLayout;
};
